export const genImageAltText = (text: string): string => `ElixirMallVN-${text.replaceAll(' ', '-').toLowerCase()}`;
